import { FIELD_UPDATE_SOURCE } from "../constants";

/**
 * Transaction update sources that represent user-initiated counterparty assignments.
 * A counterparty is considered "user-assigned" when the transaction's counterpartyIdSource
 * is one of these values, OR when counterpartyVerifiedScope is set.
 */
export const USER_ASSIGNED_COUNTERPARTY_SOURCES: FIELD_UPDATE_SOURCE[] = [
    FIELD_UPDATE_SOURCE.ADMIN,
    FIELD_UPDATE_SOURCE.ACTIONS,
    FIELD_UPDATE_SOURCE.DIRECTORY,
    FIELD_UPDATE_SOURCE.TRANSACTION_FEED,
];

export function isUserAssignedCounterpartySource(
    source: FIELD_UPDATE_SOURCE | null | undefined,
): boolean {
    return Boolean(
        source && USER_ASSIGNED_COUNTERPARTY_SOURCES.includes(source),
    );
}

export function isAutomatedCounterpartyAssignmentSource(
    source: FIELD_UPDATE_SOURCE,
): boolean {
    return !isUserAssignedCounterpartySource(source);
}
